var _circle, _path, _ellipse, _circle2, _circle3, _circle4, _ellipse2, _ellipse3, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMileageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5522,
    cy: 30.4477,
    r: 24.1791,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6137 37.6237C50.6654 38.0186 50.3921 38.5876 49.4622 39.2996C48.5662 39.9856 47.1989 40.6937 45.44 41.3748C41.9298 42.734 36.9671 43.945 31.3875 44.6748C25.808 45.4046 20.7007 45.5108 16.959 45.1001C15.0842 44.8943 13.5807 44.5617 12.5384 44.1292C11.4567 43.6804 11.0462 43.2008 10.9946 42.8059C10.9429 42.4111 11.2162 41.842 12.1461 41.1301C13.0421 40.4441 14.4094 39.736 16.1683 39.0549C19.6785 37.6957 24.6412 36.4847 30.2208 35.7549C35.8003 35.0251 40.9076 34.9189 44.6493 35.3296C46.5241 35.5353 48.0276 35.868 49.0699 36.3004C50.1516 36.7493 50.5621 37.2289 50.6137 37.6237Z",
    stroke: "#F2D861"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7731,
    cy: 40.3316,
    rx: 21.1664,
    ry: 3.83108,
    transform: "rotate(11.3276 27.7731 40.3316)",
    stroke: "#F2D861",
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.3383,
    cy: 28.9504,
    r: 1.53334,
    transform: "rotate(29.0162 51.3383 28.9504)",
    fill: "#F2D861"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2996,
    cy: 45.0708,
    r: 1.5341,
    transform: "rotate(29.0162 14.2996 45.0708)",
    fill: "#F2D861"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    stroke: "#F2D861"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.95514,
    cy: 9.85064,
    rx: 3.58209,
    ry: 3.58209,
    fill: "#F2D861"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5674,
    cy: 54.6268,
    rx: 3.58209,
    ry: 3.58209,
    fill: "#F2D861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4327 15.5196V19.1642C31.4327 19.663 31.2345 20.1413 30.8819 20.494C30.5292 20.8467 30.0508 21.0448 29.5521 21.0448C29.0533 21.0448 28.575 20.8467 28.2223 20.494C27.8696 20.1413 27.6715 19.663 27.6715 19.1642V13.5224C27.6715 13.2755 27.7201 13.0309 27.8146 12.8028C27.9091 12.5746 28.0477 12.3673 28.2223 12.1927C28.3969 12.018 28.6042 11.8795 28.8324 11.785C29.0606 11.6905 29.3051 11.6418 29.5521 11.6418C39.9386 11.6418 48.358 20.0613 48.358 30.4478C48.358 40.8344 39.9386 49.2538 29.5521 49.2538C19.1655 49.2538 10.7461 40.8344 10.7461 30.4478C10.7429 27.9777 11.2279 25.5313 12.1732 23.2493C13.1185 20.9672 14.5054 18.8944 16.2544 17.1501C16.4296 16.9727 16.6383 16.832 16.8685 16.736C17.0986 16.64 17.3455 16.5908 17.5948 16.5911C17.8442 16.5915 18.0909 16.6414 18.3208 16.738C18.5507 16.8346 18.759 16.9759 18.9338 17.1538C19.1085 17.3316 19.2461 17.5424 19.3386 17.774C19.4311 18.0055 19.4767 18.2531 19.4726 18.5024C19.4686 18.7517 19.415 18.9977 19.3149 19.2261C19.2149 19.4545 19.0705 19.6607 18.89 19.8328C17.498 21.2275 16.3944 22.8828 15.6424 24.7042C14.8904 26.5256 14.5047 28.4773 14.5073 30.4478C14.5073 38.7572 21.2427 45.4926 29.5521 45.4926C37.8615 45.4926 44.5969 38.7572 44.5969 30.4478C44.5969 22.775 38.8545 16.4449 31.4327 15.5196ZM28.1924 31.7482L24.2996 27.8554C23.9468 27.5027 23.7486 27.0242 23.7486 26.5254C23.7486 26.0265 23.9468 25.5481 24.2996 25.1953C24.6523 24.8426 25.1308 24.6444 25.6296 24.6444C26.1285 24.6444 26.6069 24.8426 26.9597 25.1953L30.8525 29.0881C31.5422 28.9646 32.2533 29.0644 32.8824 29.373C33.5114 29.6816 34.0256 30.1829 34.3499 30.804C34.6743 31.4251 34.792 32.1335 34.6859 32.826C34.5798 33.5186 34.2554 34.1593 33.7599 34.6547C33.2645 35.1502 32.6238 35.4746 31.9313 35.5807C31.2387 35.6868 30.5303 35.5691 29.9092 35.2447C29.2881 34.9204 28.7868 34.4062 28.4782 33.7772C28.1696 33.1481 28.0698 32.437 28.1933 31.7473L28.1924 31.7482Z",
    fill: "#F2D861"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageIcon);
export default __webpack_public_path__ + "static/media/mileage-icon.b053fd880bf6e52b60637554fffaa1b1.svg";
export { ForwardRef as ReactComponent };